var _path, _line, _line2, _line3, _circle, _circle2, _circle3, _circle4, _rect, _circle5, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntrnautsDevLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 160,
    viewBox: "0 0 420 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 100        C55 100 35 75 35 55        C35 30 60 20 78 25        C90 8 120 8 132 25        C155 20 175 35 175 55        C175 75 155 100 120 100        Z",
    fill: "#0E2A47"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 65,
    x2: 120,
    y2: 55,
    stroke: "#A8DADC",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 55,
    x2: 145,
    y2: 70,
    stroke: "#CDB4DB",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 55,
    x2: 100,
    y2: 85,
    stroke: "#90DBF4",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 65,
    r: 6,
    fill: "#FFFFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 55,
    r: 7,
    fill: "#4CC9F0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 70,
    r: 6,
    fill: "#CDB4DB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 85,
    r: 6,
    fill: "#90DBF4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 25,
    width: 6,
    height: 6,
    fill: "#F4A261"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 40,
    r: 3,
    fill: "#4CC9F0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 80,
    fontFamily: "Inter, system-ui, sans-serif",
    fontSize: 36,
    fill: "#0E2A47"
  }, "\n    intrnauts.\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 332,
    y: 80,
    fontFamily: "Inter, system-ui, sans-serif",
    fontSize: 36,
    fill: "#4CC9F0"
  }, "\n    dev\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntrnautsDevLogo);
export default __webpack_public_path__ + "static/media/intrnauts-dev-logo.a58a79426aa5c2f107846d18d010ba3d.svg";
export { ForwardRef as ReactComponent };